import * as React from 'react'

export const HtmlForm = (props: React.FormHTMLAttributes<HTMLFormElement>): JSX.Element => <form {...props} noValidate={true} />
